export const url = process.env.REACT_APP_API_URL || "http://localhost:3000";

export const loginLink = "https://app.glimpseit.com/login";
